const getImageNameFromUrl = (image) => {
  const splitUrl = image.split('/')
  return splitUrl[splitUrl.length - 1]
}

export default getImageNameFromUrl
